import { render, staticRenderFns } from "./crm-club-meta-data.vue?vue&type=template&id=5b17e983&scoped=true&"
import script from "./crm-club-meta-data.vue?vue&type=script&lang=js&"
export * from "./crm-club-meta-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b17e983",
  null
  
)

export default component.exports